import { SubMenu, PermissionKey } from './role-permission-types';
import { MenuType } from '../../types/enum';

export const permissionKeys: PermissionKey[] = ['view', 'create', 'edit', 'delete', 'export', 'import'];
export function applicablePermissions(menu: SubMenu): PermissionKey[] {
  if (menu.menuId === MenuType.RolePermissions) return ['view'];
  return permissionKeys.filter(key => key === 'export' ? menu.supportsExport :
    key === 'import' ? menu.supportsImport : true);
}
export const hasPermission = (menu: SubMenu) => applicablePermissions(menu).some(key => menu[key]);
export const hasAllPermissions = (menu: SubMenu) => applicablePermissions(menu).every(key => menu[key]);
export function setPermission(menu: SubMenu, field: PermissionKey, value: boolean): void {
  if (!applicablePermissions(menu).includes(field)) return;
  menu[field] = value;
  if (field === 'view' && !value) {
    permissionKeys.filter(key => key !== 'view').forEach(key => { menu[key] = false; });
  } else if (value && field !== 'view') menu.view = true;
}
export function setAllPermissions(menu: SubMenu, value: boolean): void {
  (value ? applicablePermissions(menu) : permissionKeys).forEach(key => { menu[key] = value; });
}
